import { Stack, Box, Card, Typography, useMediaQuery } from '@mui/material';
import { Link } from 'react-router-dom';

import AutoHomeIcon from '../../../assets/icons/AutoHome';
import useAnalytics from '../../../hooks/useAnalytics';
import theme from '../../../styles/theme';
import Button from '../../styledComponents/Button';

const PayAllPoliciesCard = () => {
  const isMobile = useMediaQuery(theme.breakpoints.down('tablet'));
  const { track } = useAnalytics();

  return (
    <Card
      data-testid="payAllPoliciesCard"
      component={Box}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        boxShadow: '0px 4px 8px rgba(25, 30, 43, 0.08)',
        px: { mobile: 2, tablet: 5 },
        py: { mobile: 2, tablet: 5 },
        borderRadius: 2,
        height: 'auto',
      }}
    >
      <Stack
        direction={isMobile ? 'column' : 'row'}
        spacing={isMobile ? 3 : 0}
        sx={{
          justifyContent: "space-between",
          alignItems: isMobile ? 'flex-start' : 'center'
        }}>
        <Stack direction="row" spacing={2}>
          {!isMobile && (
            <AutoHomeIcon viewBox="0 0 64 64" sx={{ width: 64, height: 64 }} />
          )}
          <Stack direction="column" spacing={0.5} sx={{
            justifyContent: "center"
          }}>
            <Typography sx={{ fontSize: 18, fontWeight: 700 }}>
              Pay multiple policies
            </Typography>
            <Typography sx={{ fontSize: 18, fontWeight: 400 }}>
              Conveniently make payments on more than one policy.
            </Typography>
          </Stack>
        </Stack>
        <Button
          component={Link}
          to="/multiple-payment"
          sx={{ mb: 1.5, minWidth: { tablet: 248, mobile: 0 } }}
          data-testid="pay-multiple-policies-button"
          onClick={() => {
            track('Payment Initiated', {
              event_type: 'Link Accessed',
              location: 'Feature Card',
              link: 'Pay multiple policies',
              payment_type: 'Multiple Policies',
            });
          }}
        >
          Pay multiple policies
        </Button>
      </Stack>
    </Card>
  );
};

export default PayAllPoliciesCard;
